import SuccessActionType from '../../common/SuccessActionType';

const clearSuccessDetails = () => ({ type: SuccessActionType.RESET_ALL });

const SuccessAction = {
  clearSuccessDetails
};

export default SuccessAction;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/SuccessAction.js
 **/